  <div class="loop-detail-modal">
    <div class="modal-header">
      <div class="title mx-auto col-12" id="modal-basic-title">
        {{ loopDetailModalTitle | lang }} - {{ 'shift_' | lang }} {{ shiftCharDetail }}
      </div>
      <img appImageSelector alt="mt-image" imageType="icon" imageKey="close-gray" class="close-modal" (click)="activeModal.dismiss()">
      <div class="col-12 text-center modal-subtitle">{{ loopDetailModalSubtitle }}</div>
    </div>

    <div class="modal-body">
      <app-main-table [tableConfig]="tableConfig" class="loop-detail-table"></app-main-table>
    </div>
  </div>